/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BusinessObjectDefinitionDescriptionSuggestionSearchKey { 
    /**
     * The namespace to which a business object definition description suggestion is related
     */
    namespace?: string;
    /**
     * The name of the business object definition to which a business object definition description suggestion is related                
     */
    businessObjectDefinitionName?: string;
    /**
     * The status code of the business object definition description suggestion
     */
    status?: string;
}
